import Box from "@mui/material/Box";
import grey from "@mui/material/colors/grey";

const BlackBorderTable = ({ children, sx, disableBorder }) => {
	let style = {
		boxSizing: "border-box",
	};
	// if (!disableBorder)
	style["border"] = `2px solid ${disableBorder ? "#00000000" : grey[900]}`;
	// else style["padding"] = "2px 0px";
	if (sx) style = { ...style, ...sx };
	return <Box sx={style}>{children}</Box>;
};

export default BlackBorderTable;
